(function() {
  console.log("HERE");
})();
